export const userContacts = {
  USER_CONTACTS_REQUEST: 'USER_CONTACTS_REQUEST',
  USER_CONTACTS_SUCCESS: 'USER_CONTACTS_SUCCESS',
  USERS_CONTACTS_FAILURE: 'USERS_CONTACTS_FAILURE',
};